import { DEFAULT_PROFILE_PIC } from '@/constants';

export default {
  _cognitoLogin() {
    return true;
  },
  _cognitoForgotPassword() {
    return true;
  },
  _cognitoSubmitResetPass() {
    return true;
  },
  _cognitoConfirmNewUser() {
    return true;
  },
  _cognitoResendNewUserCode() {
    return true;
  },
  _cognitoUpdateAttrs() {
    return true;
  },
  _cognitoChangePassword() {
    return true;
  },
  _cognitoLogout() {
    return true;
  },
  _cognitoCheckSession() {
    return true;
  },
  _refreshSession() {
    return true;
  },
  _cognitoSocialSignIn() {
    return true;
  },
  _cognitoToggleMFA() {
    return true;
  },
  _cognitoGetInitialMFAcode() {
    return true;
  },
  _cognitoVerifyInitialMFA() {
    return true;
  },
  _loginSendMFAcode() {
    return true;
  },
  _cognitoGetUserAttrs() {
    return [
      {
        Name: 'sub',
        Value: 'some-sub-id',
      },
      {
        Name: 'name',
        Value: 'Seymour Butts',
      },
      {
        Name: 'email',
        Value: 'name@email.com',
      },
      {
        Name: 'website',
        Value: 'drzzle',
      },
      {
        Name: 'picture',
        Value: DEFAULT_PROFILE_PIC,
      },
      {
        Name: 'custom:stripe_id',
        Value: 'some-stripe-id',
      },
    ];
  },
  _cognitoAmplifyGetUser() {
    return {
      attributes: {},
    };
  },
  _cognitoRestoreSession(params) {
    // add user attributes to state for editing
    const attrs = params.context._cognitoGetUserAttrs();
    params.context.$store.dispatch('setUserAttributes', attrs);
    return true;
  },
  async _cognitoSetUserAttributesState(params) {
    const list = await params.context._cognitoGetUserAttrs();
    const attrs = list.reduce((o, key) => ({ ...o, [key.Name]: key.Value }), {});
    return params.context.$store.dispatch('setCurrentUser', { values: attrs, vm: params.context });
  },
  async _cognitoValidateSession(params) {
    params.context.$store.dispatch('setUserIdentitiyId', 'us-west-2:10ac5a43-b958-4e9d-9105-6e777eb4f9cf');
    params.context.$log.debug('mock session set');
    await params.context._cognitoSetUserAttributesState();
    return true;
  },
};



// WEBPACK FOOTER //
// ./src/payloads/aws/cognito/users.js